module.exports = __webpack_public_path__ + "static/media/logo-execel.d910cedd.svg";